@if (form) {
  <rask-container-block [formGroup]="form">
    <div class="row">
      <rask-hot-doc
        [hotDoc]="hotDoc">
      </rask-hot-doc>
    </div>
    <div class="row">
      <rask-input-number class="col-2" label="Mätpunkt över stubbe" unit="cm" formControlName="matpunktOverStubbe" [rule]="validationContext.current.matpunktOverStubbe">
      </rask-input-number>
    </div>
  </rask-container-block>
}
